import React, { useContext } from 'react'

import isEmpty from 'lodash/isEmpty'
import { fade, withStyles } from '@material-ui/core/styles'
import { Link } from 'reacticoon/routing'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import SearchIcon from '@material-ui/icons/Search'
import InputBase from '@material-ui/core/InputBase'
import Paper from '@material-ui/core/Paper'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import CircularProgress from '@material-ui/core/CircularProgress'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Chip from '@material-ui/core/Chip'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
// Icônes
import PersonIcon from '@material-ui/icons/Person'
import DescriptionIcon from '@material-ui/icons/Description'
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber'
import FingerprintIcon from '@material-ui/icons/Fingerprint'
import HistoryIcon from '@material-ui/icons/History'
import BusinessIcon from '@material-ui/icons/Business'
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar'
import HomeIcon from '@material-ui/icons/Home'
import GavelIcon from '@material-ui/icons/Gavel'
import SettingsIcon from '@material-ui/icons/Settings'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import CategoryIcon from '@material-ui/icons/Category'
import WorkIcon from '@material-ui/icons/Work'
import SearchContainer from 'modules/search/container'
import PublicVariablesContext from 'modules/publicVariables/context'
import moment from 'moment'

const styles = (theme) => ({
  search: {
    position: 'relative',
    borderRadius: 12,
    backgroundColor: theme.isDark ? 'rgba(30, 41, 59, 0.95)' : 'rgba(255, 255, 255, 0.95)',
    border: `2px solid rgba(102, 126, 234, 0.3)`,
    backdropFilter: 'blur(10px)',
    transition: 'all 0.3s ease',
    '&:hover': {
      borderColor: 'rgba(102, 126, 234, 0.6)',
      backgroundColor: theme.isDark ? 'rgba(30, 41, 59, 1)' : 'rgba(255, 255, 255, 1)',
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#667eea',
  },
  inputRoot: {
    color: theme.isDark ? 'rgba(255, 255, 255, 0.95)' : 'rgba(0, 0, 0, 0.87)',
    fontSize: 15,
    fontWeight: 500,
  },
  inputInput: {
    padding: theme.spacing(1.5, 1, 1.5, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '25ch',
      '&:focus': {
        width: '40ch',
      },
    },
  },
  popup: {
    position: 'fixed',
    top: 50,
    left: '50%',
    marginLeft: '-425px',
    minWidth: 650,
    width: 850,
    maxWidth: 850,
    background: theme.isDark ? 'rgba(15, 23, 42, 0.98)' : 'rgba(255, 255, 255, 0.98)',
    border: `2px solid rgba(102, 126, 234, 0.3)`,
    borderRadius: 16,
    backdropFilter: 'blur(20px)',
    boxShadow: theme.isDark ? '0 20px 60px rgba(0, 0, 0, 0.5)' : '0 20px 60px rgba(0, 0, 0, 0.15)',
    overflow: 'hidden',
    zIndex: 9999,
    [theme.breakpoints.down('sm')]: {
      left: theme.spacing(2),
      marginLeft: 0,
      width: '90vw',
      minWidth: '90vw',
      maxWidth: '90vw',
    },
  },
  listItem: {
    padding: '16px 20px',
    borderBottom: theme.isDark ? '1px solid rgba(255, 255, 255, 0.05)' : '1px solid rgba(0, 0, 0, 0.05)',
    transition: 'all 0.2s ease',
    cursor: 'pointer',
    '&:hover': {
      background: theme.isDark ? 'rgba(102, 126, 234, 0.15)' : 'rgba(102, 126, 234, 0.08)',
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  history: {
    overflow: 'hidden',
    overflowY: 'auto',
    maxHeight: '60vh',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  historyBtn: {
    cursor: 'pointer',
    width: 32,
    color: theme.isDark ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
    transition: 'color 0.2s ease',
    '&:hover': {
      color: '#667eea',
    },
  },
  searchPending: {
    marginRight: theme.spacing(0.5),
    color: '#667eea',
  },
  resultCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    width: '100%',
  },
  resultIcon: {
    width: 40,
    height: 40,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.isDark ? 'rgba(102, 126, 234, 0.15)' : 'rgba(102, 126, 234, 0.1)',
    color: '#667eea',
    flexShrink: 0,
    marginRight: 16,
  },
  resultContent: {
    flex: 1,
    minWidth: 0,
  },
  resultTitle: {
    fontSize: 15,
    fontWeight: 600,
    color: theme.isDark ? 'rgba(255, 255, 255, 0.95)' : 'rgba(0, 0, 0, 0.87)',
    marginBottom: 4,
  },
  resultSubtitle: {
    fontSize: 13,
    color: theme.isDark ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  resultActions: {
    display: 'flex',
    gap: 8,
    flexShrink: 0,
  },
  actionIcon: {
    padding: 8,
    color: theme.isDark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)',
    transition: 'all 0.2s ease',
    '&:hover': {
      color: '#667eea',
      background: theme.isDark ? 'rgba(102, 126, 234, 0.1)' : 'rgba(102, 126, 234, 0.08)',
    },
  },
  onlineBadge: {
    background: '#22c55e',
    color: 'white',
    fontSize: 11,
    height: 20,
    fontWeight: 600,
  },
  typeBadge: {
    fontSize: 11,
    height: 20,
    fontWeight: 600,
    borderRadius: 6,
  },
  inGamePlayerInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  isOnlineDot: {
    background: '#22c55e',
    height: 8,
    width: 8,
    borderRadius: '50%',
    boxShadow: '0 0 10px rgba(34, 197, 94, 0.6)',
  },
})

const Search = ({ route, classes }) => {
  const [isFocus, setIsFocus] = React.useState(false)

  const { weapons } = useContext(PublicVariablesContext)

  const onQuitFocus = () => setIsFocus(false)
  
  // Fonction pour gérer le clic sur un résultat
  // On force toujours un reload complet pour s'assurer que la page se met à jour
  return (
    <SearchContainer disableAutomaticSend>
      {({
        query,
        onQueryChange,
        onSubmit,
        onResetQuery,
        results,
        isSearchPending,
        searchHistory,
        showHistory,
        setShowHistory,
        saveCurrentToHistory,
      }) => {
        // Fonction pour gérer le clic sur un résultat
        // Ne PAS rappeler onSubmit() ici : on a déjà les résultats affichés.
        // Ne PAS forcer window.location.reload() : la navigation SPA via <Link>
        // suffit. Ces deux comportements provoquaient une rafale de
        // GET_QUERY_RESULTS à chaque clic (parfois plusieurs si l'utilisateur
        // re-cliquait pendant le délai du reload).
        const handleResultClickWithHistory = () => {
          saveCurrentToHistory()
          onQuitFocus()
        }
        
        return (
        <ClickAwayListener
          onClickAway={() => {
            onResetQuery()
            onQuitFocus()
          }}
        >
          <div
            className={classes.search}
            // onBlur={() => setIsFocus(false)}
          >
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Rechercher"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ 'aria-label': 'search' }}
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              onFocus={() => setIsFocus(true)}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  // Ignore l'auto-repeat clavier (touche maintenue) qui
                  // pouvait générer plusieurs dizaines de requêtes/seconde.
                  if (event.repeat) return
                  onSubmit()
                }
              }}
              endAdornment={
                isSearchPending ? (
                  <CircularProgress size={28} className={classes.searchPending} />
                ) : (
                  <ExpandMoreIcon
                    onClick={() => setShowHistory(!showHistory)}
                    className={classes.historyBtn}
                  />
                )
              }
            />

            {showHistory && (
              <ClickAwayListener onClickAway={() => setShowHistory(false)}>
                <Paper className={classes.popup} variant="outlined" elevation={3}>
                  <List className={classes.history}>
                    {isEmpty(searchHistory) ? (
                      <ListItem>
                        <ListItemText primary="Pas d'historique" />
                      </ListItem>
                    ) : (
                      searchHistory.map((query, index) => (
                        <ListItem
                          key={index}
                          className={classes.listItem}
                          onClick={() => {
                            // On met à jour la query dans le champ de recherche
                            onQueryChange(query)
                            // On soumet directement avec la query en paramètre
                            onSubmit(query)
                            // On ferme l'historique pour afficher les résultats
                            setShowHistory(false)
                            // On active le focus pour afficher les résultats
                            setIsFocus(true)
                          }}
                        >
                          {query}
                        </ListItem>
                      ))
                    )}
                  </List>
                </Paper>
              </ClickAwayListener>
            )}

            {isFocus && results && !showHistory && (
              <Paper className={classes.popup} variant="outlined" elevation={3}>
                <List>
                  {isEmpty(results) ? (
                    <ListItem>
                      <ListItemText primary="Pas de résultat" />
                    </ListItem>
                  ) : (
                    results.map((result, index) => (
                      <ListItem className={classes.listItem} key={index} data={result}>
                        {result.type === 'faction' && (
                          <Box className={classes.resultCard}>
                            <Box className={classes.resultIcon} style={{ background: 'rgba(239, 68, 68, 0.15)', color: '#ef4444' }}>
                              <BusinessIcon />
                            </Box>
                            <Link 
                              to="FACTION"
                              query={{
                                faction: result.data.faction.name,
                                tab: 'members',
                              }}
                              className={classes.resultContent}
                              style={{ textDecoration: 'none' }}
                              onClick={() => handleResultClickWithHistory()}
                            >
                              <Box className={classes.resultTitle}>
                                {result.data.faction.label}
                              </Box>
                              <Box className={classes.resultSubtitle}>
                                Faction • {result.data.faction.name}
                              </Box>
                            </Link>
                            <Box className={classes.resultActions}>
                              <Tooltip title="Voir la faction">
                                <IconButton
                                  className={classes.actionIcon}
                                  size="small"
                                  component={Link}
                                  to="FACTION"
                                  query={{
                                    faction: result.data.faction.name,
                                    tab: 'members',
                                  }}
                                  onClick={onQuitFocus}
                                >
                                  <BusinessIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Box>
                        )}
                        {result.type === 'factionVehicle' && (
                          <Box className={classes.resultCard}>
                            <Box className={classes.resultIcon} style={{ background: 'rgba(245, 158, 11, 0.15)', color: '#f59e0b' }}>
                              <LocalShippingIcon />
                            </Box>
                            <Link
                              to="FACTION"
                              query={{
                                faction: result.data.faction,
                                tab: 'vehicles',
                                plate: result.data.plate.toUpperCase(),
                              }}
                              className={classes.resultContent}
                              style={{ textDecoration: 'none' }}
                              onClick={() => handleResultClickWithHistory()}
                            >
                              <Box className={classes.resultTitle}>
                                {result.data.plate.toUpperCase()} - {result.data.label}
                              </Box>
                              <Box className={classes.resultSubtitle}>
                                Véhicule de faction
                              </Box>
                            </Link>
                            <Box className={classes.resultActions}>
                              <Tooltip title="Voir la faction">
                                <IconButton
                                  className={classes.actionIcon}
                                  size="small"
                                  component={Link}
                                  to="FACTION"
                                  query={{
                                    faction: result.data.faction,
                                    tab: 'vehicles',
                                  }}
                                  onClick={onQuitFocus}
                                >
                                  <BusinessIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Box>
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'onplayer' && (
                          <Link
                            to="PLAYER"
                            params={{ identifier: result.data.weaponLocation }}
                            className={classes.fullName}
                            query={
                              {
                                tab: 'inventory',
                                weaponSn: result.data.weaponData.data.sn
                              }
                            }
                            onClick={() => handleResultClickWithHistory()}
                          >
                            {`Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} sur le joueur ${result.data.weaponLocationTypeDetail}`}
                          </Link>
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'bag' && (
                          <Link
                            to="PLAYER"
                            params={{ identifier: result.data.weaponLocationTypeDetail.data.identifier }}
                            className={classes.fullName}
                            query={
                              {
                                tab: 'inventory',
                                weaponSn: result.data.weaponData.data.sn
                              }
                            }
                            onClick={() => handleResultClickWithHistory()}
                          >
                            {`Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans le sac du joueur ${result.data.weaponLocationTypeDetail.data.fullName}`}
                          </Link>
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'civ_vehicle' && (
                          <Link
                            to={'PLAYER'}
                            params={{ identifier: result.data.weaponLocationTypeDetail.data.owner }}
                            className={classes.fullName}
                            query={{
                              tab: 'vehicles',
                              ...(result.data.weaponLocationTypeDetail.data.plate && {
                                plate: result.data.weaponLocationTypeDetail.data.plate.toUpperCase(),
                                weaponSn: result.data.weaponData.data.sn
                              })
                            }}
                            onClick={() => handleResultClickWithHistory()}
                          >
                            {`Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans le véhicule ${result.data.weaponLocationTypeDetail.data.plate} du joueur ${result.data.weaponLocationTypeDetail.data.ownerLabel}`}
                          </Link>
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'faction_vehicle' && (
                          <Link
                            to="FACTION"
                            query={{
                              faction: result.data.weaponLocationTypeDetail.data.owner,
                              tab: 'vehicles',
                              plate: result.data.weaponLocationTypeDetail.data.plate.toUpperCase(),
                              weaponSn: result.data.weaponData.data.sn
                            }}
                            params={{ identifier: result.data.weaponLocationTypeDetail.data.owner }}
                            className={classes.fullName}
                            onClick={() => handleResultClickWithHistory()}
                          >
                            {`Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans le véhicule ${result.data.weaponLocationTypeDetail.data.plate} de la faction ${result.data.weaponLocationTypeDetail.data.ownerLabel}`}
                          </Link>
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'prop' && (
                          <Link
                            to="PLAYER"
                            params={{ identifier: result.data.weaponLocationTypeDetail.data.owner }}
                            className={classes.fullName}
                            query={
                              result.data.weaponLocationTypeDetail.data.propId && {
                                propId: result.data.weaponLocationTypeDetail.data.propId,
                                tab: 'inventory',
                                weaponSn: result.data.weaponData.data.sn
                              }
                            }
                            onClick={() => handleResultClickWithHistory()}
                          >
                            {`Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans le prop ${result.data.weaponLocationTypeDetail.data.propId} du joueur ${result.data.weaponLocationTypeDetail.data.ownerLabel}`}
                          </Link>
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'donatorFarm' && (
                          <Link
                            to="PLAYER"
                            params={{ identifier: result.data.weaponLocationTypeDetail.data.owner }}
                            className={classes.fullName}
                            query={
                              result.data.weaponLocationTypeDetail.data.type && {
                                inventoryId: `donatorFarm_${result.data.weaponLocationTypeDetail.data.type}`,
                                tab: 'inventory',
                                weaponSn: result.data.weaponData.data.sn
                              }
                            }
                            onClick={() => handleResultClickWithHistory()}
                          >
                            {`Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans le coffre ${result.data.weaponLocationTypeDetail.data.typeLabel} du joueur ${result.data.weaponLocationTypeDetail.data.ownerLabel}`}
                          </Link>
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'locker' && (
                          <Link
                            to="PLAYER"
                            params={{ identifier: result.data.weaponLocationTypeDetail.data.owner }}
                            className={classes.fullName}
                            query={
                              result.data.weaponLocationTypeDetail.data.type && {
                                inventoryId: `locker_${result.data.weaponLocationTypeDetail.data.type}`,
                                tab: 'inventory',
                                weaponSn: result.data.weaponData.data.sn
                              }
                            }
                            onClick={() => handleResultClickWithHistory()}
                          >
                            {`Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans le casier ${result.data.weaponLocationTypeDetail.data.typeLabel} du joueur ${result.data.weaponLocationTypeDetail.data.ownerLabel}`}
                          </Link>
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'civ_property' && (
                          <Link
                            to="PLAYER"
                            params={{ identifier: result.data.weaponLocationTypeDetail.data.owner }}
                            className={classes.fullName}
                            query={
                              result.data.weaponLocationTypeDetail.data.propertyId && {
                                propertyId: result.data.weaponLocationTypeDetail.data.propertyId,
                                tab: 'properties',
                                weaponSn: result.data.weaponData.data.sn
                              }
                            }
                            onClick={() => handleResultClickWithHistory()}
                          >
                            {`Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans une propriété du joueur ${result.data.weaponLocationTypeDetail.data.ownerLabel}`}
                          </Link>
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'faction_property' && (
                          <Link
                            to="FACTION"
                            query={{
                              faction: result.data.weaponLocationTypeDetail.data.faction,
                              tab: 'properties',
                              propertyId: result.data.weaponLocationTypeDetail.data.propertyId,
                              weaponSn: result.data.weaponData.data.sn
                            }}
                            className={classes.fullName}
                            onClick={() => handleResultClickWithHistory()}
                          >
                            {`Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans une propriété de la faction ${result.data.weaponLocationTypeDetail.data.factionLabel}`}
                          </Link>
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'oldproperty' && (
                          `Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans une ancienne propriété du joueur ${result.data.weaponLocationTypeDetail.data.ownerLabel} (non visible)`
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'property_letterbox' && (
                          <Link
                            to="PLAYER"
                            params={{ identifier: result.data.weaponLocationTypeDetail.data.owner }}
                            className={classes.fullName}
                            query={
                              result.data.weaponLocationTypeDetail.data.propertyId && {
                                propertyId: result.data.weaponLocationTypeDetail.data.propertyId,
                                tab: 'properties',
                                weaponSn: result.data.weaponData.data.sn
                              }
                            }
                            onClick={() => handleResultClickWithHistory()}
                          >
                            {`Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans la boite aux lettres d'une propriété du joueur ${result.data.weaponLocationTypeDetail.data.ownerLabel}`}
                          </Link>
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'property_letterbox_notowned' && (
                          `Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans la boite aux lettres d'une ancienne propriété (${result.data.weaponLocationTypeDetail.data.propertyData}) (non visible)`
                        )}
                        
                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'motelinv' && (
                          <Link
                            to="PLAYER"
                            params={{ identifier: result.data.weaponLocationTypeDetail.data.owner }}
                            className={classes.fullName}
                            query={
                              result.data.weaponLocationTypeDetail.data.type && {
                                inventoryId: result.data.weaponLocationTypeDetail.data.type,
                                tab: 'inventory',
                                weaponSn: result.data.weaponData.data.sn
                              }
                            }
                            onClick={() => handleResultClickWithHistory()}
                          >
                            {`Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans la chambre d'hôtel ${result.data.weaponLocationTypeDetail.data.typeLabel} du joueur ${result.data.weaponLocationTypeDetail.data.ownerLabel}`}
                          </Link>
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'inventory_society' && (
                          <Link
                            to="FACTION"
                            params={{ identifier: result.data.weaponLocationTypeDetail.data.owner }}
                            className={classes.fullName}
                            query={
                              result.data.weaponLocationTypeDetail.data.faction && {
                                faction: result.data.weaponLocationTypeDetail.data.faction,
                                tab: 'weapons',
                                safe: result.data.weaponLocationTypeDetail.data.safe,
                                weaponSn: result.data.weaponData.data.sn,
                                weaponClassName: result.data.weaponData.name
                              }
                            }
                            onClick={() => handleResultClickWithHistory()}
                          >
                            {`Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans l'inventaire ${result.data.weaponLocationTypeDetail.data.safe} de la faction ${result.data.weaponLocationTypeDetail.data.factionLabel}`}
                          </Link>
                        )}

                        {result.type === 'weapon' && result.data.weaponLocationType === 'bayinventory' && result.data.weaponLocationTypeDetail.type === 'unknowninventory' && (
                          `Arme : ${weapons.find(e => e.name === result.data.weaponData.name).label} dans un inventaire inconnu (${result.data.weaponLocation}) (non visible)`
                        )}
                      
                        {result.type === 'playerVehicle' && (
                          <Box className={classes.resultCard}>
                            <Box className={classes.resultIcon} style={{ background: 'rgba(59, 130, 246, 0.15)', color: '#3b82f6' }}>
                              <DirectionsCarIcon />
                            </Box>
                            <Link
                              to="PLAYER"
                              params={{ identifier: result.data.player.identifier }}
                              query={{
                                tab: 'vehicles',
                                ...(result.data.plate && {
                                  plate: result.data.plate.toUpperCase(),
                                })
                              }}
                              className={classes.resultContent}
                              style={{ textDecoration: 'none' }}
                              onClick={() => handleResultClickWithHistory()}
                            >
                              <Box className={classes.resultTitle}>
                                {result.data.plate ? result.data.plate.toUpperCase() : 'Véhicule sans plaque'}
                              </Box>
                              <Box className={classes.resultSubtitle}>
                                Véhicule de {result.data.player.fullName}
                              </Box>
                            </Link>
                            <Box className={classes.resultActions}>
                              <Tooltip title="Voir les véhicules">
                                <IconButton
                                  className={classes.actionIcon}
                                  size="small"
                                  component={Link}
                                  to="PLAYER"
                                  params={{ identifier: result.data.player.identifier }}
                                  query={{
                                    tab: 'vehicles',
                                    ...(result.data.plate && {
                                      plate: result.data.plate.toUpperCase(),
                                    })
                                  }}
                                  onClick={onQuitFocus}
                                >
                                  <DirectionsCarIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Box>
                        )}

                        {result.type === 'oldProperty' && (
                          <Link
                            to='PLAYER'
                            params={{ identifier: result.data.player.identifier }}
                            className={classes.fullName}
                            onClick={() => handleResultClickWithHistory()}
                          >
                            Ancienne propriété de {result.data.player.fullName}
                          </Link>
                        )}

                        {result.type === 'civ_property' && (
                          <Box className={classes.resultCard}>
                            <Box className={classes.resultIcon} style={{ background: 'rgba(16, 185, 129, 0.15)', color: '#10b981' }}>
                              <HomeIcon />
                            </Box>
                            <Link
                              to='PLAYER'
                              params={{ identifier: result.data.player.identifier }}
                              query={{
                                propertyId: result.data.propertyId,
                                tab: 'properties'
                              }}
                              className={classes.resultContent}
                              style={{ textDecoration: 'none' }}
                              onClick={() => handleResultClickWithHistory()}
                            >
                              <Box className={classes.resultTitle}>
                                Propriété #{result.data.propertyId}
                              </Box>
                              <Box className={classes.resultSubtitle}>
                                Propriété de {result.data.player.fullName}
                              </Box>
                            </Link>
                            <Box className={classes.resultActions}>
                              <Tooltip title="Voir le joueur">
                                <IconButton
                                  className={classes.actionIcon}
                                  size="small"
                                  component={Link}
                                  to="PLAYER"
                                  params={{ identifier: result.data.player.identifier }}
                                  onClick={onQuitFocus}
                                >
                                  <PersonIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Box>
                        )}

                        {result.type === 'faction_property' && (
                          <Box className={classes.resultCard}>
                            <Box className={classes.resultIcon} style={{ background: 'rgba(16, 185, 129, 0.15)', color: '#10b981' }}>
                              <HomeIcon />
                            </Box>
                            <Link
                              to='FACTION'
                              query={{
                                faction: result.data.faction,
                                tab: 'properties',
                                propertyId: result.data.propertyId
                              }}
                              className={classes.resultContent}
                              style={{ textDecoration: 'none' }}
                              onClick={() => handleResultClickWithHistory()}
                            >
                              <Box className={classes.resultTitle}>
                                Propriété #{result.data.propertyId}
                              </Box>
                              <Box className={classes.resultSubtitle}>
                                Propriété de la faction {result.data.factionLabel}
                              </Box>
                            </Link>
                            <Box className={classes.resultActions}>
                              <Tooltip title="Voir la faction">
                                <IconButton
                                  className={classes.actionIcon}
                                  size="small"
                                  component={Link}
                                  to="FACTION"
                                  query={{
                                    faction: result.data.faction,
                                    tab: 'properties'
                                  }}
                                  onClick={onQuitFocus}
                                >
                                  <BusinessIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Box>
                        )}

                        {result.type === 'playerProp' && (
                          <Link
                            to='PLAYER'
                            params={{ identifier: result.data.player.identifier }}
                            query={
                              result.data.propId && {
                                propId: result.data.propId,
                                tab: 'inventory'
                              }
                            }
                            className={classes.fullName}
                            onClick={() => handleResultClickWithHistory()}
                          >
                            Prop du joueur {result.data.player.fullName}
                          </Link>
                        )}

                        {(result.type === 'player' || result.type === 'inGamePlayer') && (
                          <Box className={classes.resultCard}>
                            <Box className={classes.resultIcon}>
                              <PersonIcon />
                            </Box>
                            <Link
                              to="PLAYER"
                              params={{ identifier: result.data.player.identifier }}
                              query={
                                result.data.plate
                                  ? { tab: 'vehicles', plate: result.data.plate }
                                  : undefined
                              }
                              className={classes.resultContent}
                              style={{ textDecoration: 'none' }}
                              onClick={() => handleResultClickWithHistory()}
                            >
                              <Box className={classes.resultTitle}>
                                {result.type === 'inGamePlayer' ? (
                                  <Box className={classes.inGamePlayerInfo}>
                                    <span className={classes.isOnlineDot} />
                                    <span style={{ marginLeft: 8 }}>
                                      [{result.data.player.inGameId}] {result.data.player.fullName}
                                    </span>
                                  </Box>
                                ) : (
                                  <span>{result.data.player.fullName}</span>
                                )}
                              </Box>
                              <Box className={classes.resultSubtitle}>
                                {result.data.player.jobWhitelisted && result.data.player.jobLabel && result.data.player.jobLabel}
                                {result.data.player.job2Whitelisted && result.data.player.job2Label && result.data.player.jobWhitelisted && result.data.player.jobLabel && ' • '}
                                {result.data.player.job2Whitelisted && result.data.player.job2Label && result.data.player.job2Label}
                                {result.data.player.playTime > 0 && (
                                  <>
                                    {((result.data.player.jobWhitelisted && result.data.player.jobLabel) || (result.data.player.job2Whitelisted && result.data.player.job2Label)) && ' • '}
                                    {(() => {
                                      const totalSeconds = result.data.player.playTime
                                      const years = Math.floor(totalSeconds / (365 * 24 * 3600))
                                      const days = Math.floor((totalSeconds % (365 * 24 * 3600)) / (24 * 3600))
                                      const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600)
                                      
                                      const parts = []
                                      if (years > 0) parts.push(`${years}an${years > 1 ? 's' : ''}`)
                                      if (days > 0) parts.push(`${days}j`)
                                      if (hours > 0 || parts.length === 0) parts.push(`${hours}h`)
                                      
                                      return parts.join(' ') + ' de jeu'
                                    })()}
                                  </>
                                )}
                                {result.data.player.lastConnection && result.type !== 'inGamePlayer' && (
                                  <>
                                    {((result.data.player.jobWhitelisted && result.data.player.jobLabel) || (result.data.player.job2Whitelisted && result.data.player.job2Label) || result.data.player.playTime > 0) && ' • '}
                                    Vu {moment(result.data.player.lastConnection).fromNow()}
                                  </>
                                )}
                                {!(result.data.player.jobWhitelisted && result.data.player.jobLabel) && !(result.data.player.job2Whitelisted && result.data.player.job2Label) && !result.data.player.playTime && !result.data.player.lastConnection && 'Joueur'}
                              </Box>
                            </Link>

                            <Box className={classes.resultActions}>
                              <Tooltip title="Gestion" arrow placement="top">
                                <span>
                                  <IconButton
                                    className={classes.actionIcon}
                                    size="small"
                                    component={Link}
                                    to="PLAYER"
                                    params={{ identifier: result.data.player.identifier }}
                                    onClick={() => {
                                      if (route.name === 'PLAYER') {
                                        setTimeout(() => {
                                          window.location.reload()
                                        }, 100)
                                      }
                                      onQuitFocus()
                                    }}
                                  >
                                    <PersonIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>

                              <Tooltip title="Casier judiciaire" arrow placement="top">
                                <span>
                                  <IconButton
                                    className={classes.actionIcon}
                                    size="small"
                                    component={Link}
                                    to="PLAYER_RECORD"
                                    params={{ identifier: result.data.player.identifier }}
                                    onClick={onQuitFocus}
                                  >
                                    <GavelIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>

                              <Tooltip title="Tickets" arrow placement="top">
                                <span>
                                  <IconButton
                                    className={classes.actionIcon}
                                    size="small"
                                    component={Link}
                                    to="PLAYER_TICKETS"
                                    params={{ identifier: result.data.player.identifier, displayId: 'all' }}
                                    onClick={onQuitFocus}
                                  >
                                    <ConfirmationNumberIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>

                              <Tooltip title="Identifiants" arrow placement="top">
                                <span>
                                  <IconButton
                                    className={classes.actionIcon}
                                    size="small"
                                    component={Link}
                                    to="PLAYER_SPY"
                                    params={{ identifier: result.data.player.identifier }}
                                    onClick={onQuitFocus}
                                  >
                                    <FingerprintIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>

                              <Tooltip title="Logs" arrow placement="top">
                                <span>
                                  <IconButton
                                    className={classes.actionIcon}
                                    size="small"
                                    component={Link}
                                    to="LOGS"
                                    query={{ identifier: result.data.player.identifier }}
                                    onClick={onQuitFocus}
                                  >
                                    <HistoryIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </Box>
                          </Box>
                        )}
                      </ListItem>
                    ))
                  )}
                </List>
              </Paper>
            )}
          </div>
        </ClickAwayListener>
      )
    }}
    </SearchContainer>
  )
}

export default withStyles(styles)(Search)
